import React from "react";
import CaseListPage from "./CaseListPage";
import { mineCasesConfig } from "./caseListConfig";

const IndexUserMineCases = () => (
  <CaseListPage config={ mineCasesConfig } />
);

export default IndexUserMineCases;
